import React, { useCallback, useEffect, useState } from "react";
import "./index.scss";

interface INoTasksAssignedComponent {
  message: string;
}
const NoTasksAssignedComponent: React.FC<INoTasksAssignedComponent> = (
  props
) => {
  return (
    <div className="no-tasks-assigned-component">
      <div className="no-tasks-assigned-left-icon">
        <span className="no-tasks-assigned-icon" style={{ width: 130 }}></span>
      </div>
      <div className="no-tasks-assigned-text">
        {props.message.split("\n\n").map((x) => (
          <div className="margin-top">
            {x}
          </div>
        ))}
      </div>
    </div>
  );
};

export default NoTasksAssignedComponent;
